<div class="card-header" >
  <span style="padding-left: 11px;">Refraction Config</span>
</div>

<div class="content-body" >
    <div class="row" style="padding: 20px 0px;">
      <div class="col-lg-4">
        <label>Select Account</label>
        <ng-select style="width:100%" [items]="accounts" #t name="accounts" bindLabel="accountName" [clearable]="true" [searchable]="true"
          bindValue="accountId" (change)="fetchWorkflowDetailsForAccount()" [(ngModel)]="accountId" placeholder="Select account">
        </ng-select>
      </div>
    </div>

    <div class="row" style="padding: 10px 5px;" *ngIf="showData">
      <div class="col-md-12 col-sm-12 col-xs-12" style="padding-left: 0px;padding-right: 0px;">
        <table class="table table-border-yellow">
          <tbody>
            <tr *ngFor="let itr of customFields  ; let fieldIndex=index" [class.disabled]="false">
              <td class="form-group" style="padding-left: 0px;padding-right: 0px;">
                <div class="form-group col-xs-12" *ngIf="fieldIndex === 0" style="margin:10px 0px;font-weight: bold;">Objective</div>
                <div class="form-group col-xs-12">
                  {{itr.fieldName.replaceAll('_',' ')}}
                </div>
                <div class="col-lg-1 col-xs-12 center" style="font-size: 20px;color : #cdcdcd" ><i class="fa {{itr.id != null ? 'fa-check-circle green' : 'fa-check-circle-o'}}" aria-hidden="true"></i>
                </div>
                <div class="form-group col-lg-2 col-md-3 col-sm-4 col-xs-12">
                  <div class="col-xs-12">
                    <input type="number"
                      [(ngModel)]="itr.fieldMinValue" class="form-control" placeholder="Min length"
                      [attr.disabled]="itr.fieldName === 'VISUAL_ACUITY' ? required : null"/></div>
                  </div>
                <div class="form-group col-lg-2 col-md-3 col-sm-4 col-xs-12"><input type="number"
                    [(ngModel)]="itr.fieldMaxValue" class="form-control" placeholder="Max length"
                    (keyup)="validateLength(itr.fieldMinValue,itr.fieldMaxValue,itr.fieldStepValue,itr.fieldName)" [attr.disabled]="itr.fieldName === 'VISUAL_ACUITY' ? required : null"></div>
                <div class="form-group col-lg-2 col-md-3 col-sm-4 col-xs-12"><input type="number"
                    [(ngModel)]="itr.fieldStepValue" class="form-control" min=0 placeholder="Step Value"
                    (keyup)="validateLength(itr.fieldMinValue,itr.fieldMaxValue,itr.fieldStepValue,itr.fieldName)" [attr.disabled]="itr.fieldName === 'VISUAL_ACUITY' ? required : null"/></div>
                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                  <input type="text" class="form-control" placeholder="Additional Info (comma seperated)"
                    [(ngModel)]="itr.fieldAdditionalnfo" >
                </div>
                <div class="form-group col-lg-2 col-md-3 col-sm-4 col-xs-12">
                  <div class="chiller_cb">
                    <input id="isMandatory_{{fieldIndex}}" [(ngModel)]="itr.isMandatory"
                      name="isMandatory_{{fieldIndex}}" type="checkbox" class="form-control" required/>
                    <label style="font-weight: normal;" for="isMandatory_{{fieldIndex}}">Mandatory</label>
                    <span></span>
                  </div>
                </div>
                <div class="form-group col-xs-12" *ngIf="fieldIndex === 2" style="margin:10px 0px;font-weight: bold;">Subjective</div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-12 text-center mTop15">
            <button data-dismiss="modal" style="margin-right: 5px;background-color: rgb(87,200,231);color:white;" [disabled]="disableButtonFlag"
                (click)="saveRefractionConfig()" class="btn btn-sm marginLR5">
                <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Config</button>
        </div>
      </div>
    </div>